// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateEditUser_wrapper__B-L+9","formGroup":"CreateEditUser_formGroup__5AYMa","year":"CreateEditUser_year__x-xxY","checkboxGroup":"CreateEditUser_checkboxGroup__kGQyc"};